module.exports = __webpack_public_path__ + "img/pic_2.d30eba01.jpg";